// @flow

import type { Timer } from './types';

export const SKIP_OPT_VALUE_SCHEDULED: number = 0; // value of skip_opt property meaning that the timer is scheduled or PTAT
export const SKIP_OPT_VALUE_CONFLICTS: number = 1; // value of skip_opt property meaning that the timer is conflicting
export const SKIP_OPT_VALUE_SKIPPED: number = 2; // value of skip_opt property meaning that the timer was set to be skipped

export const SKIP_OPT_SCHEDULED: string = 'Scheduled';
export const SKIP_OPT_CONFLICTS: string = 'Conflict';
export const SKIP_OPT_SKIPPED: string = 'Skipped';

export const getRecordingTypeName = (timer: Timer) => {
  switch (timer.skip_opt) {
    case SKIP_OPT_VALUE_SCHEDULED:
      return SKIP_OPT_SCHEDULED;
    case SKIP_OPT_VALUE_SKIPPED:
      return SKIP_OPT_SKIPPED;
    case SKIP_OPT_VALUE_CONFLICTS:
      return SKIP_OPT_CONFLICTS;
    default:
      return SKIP_OPT_SCHEDULED;
  }
};
